import React, { useState } from 'react';
import { FiGlobe } from 'react-icons/fi';

import { ColorPalette } from 'theme/colors';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import useStoreTranslation from 'hooks/useStoreTranslation';
import TravelerLoyaltyContainer from 'screens/containers/TravelerLoyalty';

import LanguageSelector from './components/LanguageSelector';
import { MenuItem, Icon, ItemTitle, IconEdit, IconContainer } from './styles';

type Props = {
  setLoading: (loading: boolean) => void;
};

const Preferences = ({ setLoading }: Props) => {
  const { t } = useStoreTranslation();
  const [showLoyalty, setShowLoyalty] = useState(false);
  const [showLanguage, setShowLanguage] = useState(false);

  const handleCloseLoyalty = () => setShowLoyalty(false);

  return (
    <>
      <MenuItem onClick={() => setShowLoyalty(true)}>
        <IconContainer>
          <Icon src="/images/traveler-profile/ribbon.svg" />
        </IconContainer>
        <ItemTitle>{t('preferences.options.loyalty')}</ItemTitle>
        <IconEdit src="/images/edit-arrow-right.svg" />
      </MenuItem>

      <MenuItem onClick={() => setShowLanguage(true)}>
        <IconContainer>
          <FiGlobe color={ColorPalette.HEX.PineTree} />
        </IconContainer>
        <ItemTitle>{t('preferences.options.language')}</ItemTitle>
        <IconEdit src="/images/edit-arrow-right.svg" />
      </MenuItem>

      <ApplicationOverlayContent sidebar show={showLoyalty} onClose={handleCloseLoyalty}>
        <TravelerLoyaltyContainer onClose={handleCloseLoyalty} />
      </ApplicationOverlayContent>

      <LanguageSelector show={showLanguage} setShow={setShowLanguage} setLoading={setLoading} />
    </>
  );
};

export default Preferences;
